/* eslint-disable @angular-eslint/directive-selector */
import { AfterViewChecked, Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * This directive is used to enhance the mat-icon with a data attribute that makes it selectable via CSS.
 */
@Directive({
  selector: 'mat-icon',
  standalone: true,
})
export class MatIconDescriptorDirective implements AfterViewChecked {
  constructor(private readonly elementRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewChecked(): void {
    const el = this.elementRef.nativeElement;
    const elContent = el.textContent?.trim();
    if (!elContent || elContent === '') return;

    const aliases = new Set();
    const shortestMatIconCharacterCount = 2;

    aliases.add(elContent);

    // Add all child contents to the descriptor attribute because in some places the mat-icon contains more content than just its name,
    // e.g. "<span>perm_media<span><span>22</span>", which results in "perm_media22". Hence the css selector would not match
    if (el.childElementCount > 0) {
      [...el.children].forEach((child) => {
        const content = child.textContent.trim();
        if (content && content.length >= shortestMatIconCharacterCount) {
          aliases.add(content);
        }
      });
    }

    const label = `[${[...aliases].join('][')}]`; // Wrap in brackets to easily select the value with CSS
    this.renderer.setAttribute(el, 'data-sp-icon', label);
  }
}
